/**
 * Created by cbikar on 2/2/2016.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("personalization-web-agent-templates/agentFileSharingEdit.tmpl");
    var Button = require("ui/button/Button");
    var ToggleButton = require("ui/toggle-button/toggleButton");
    var Settings = require("codeTables/settings.json");
    var ENABLED_VALUE = "true";

    var AgentFileSharingEditView = {};
    LE.module("LEPersonalization", function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        AgentFileSharingEditView = Marionette.CompositeView.extend({
            template: template,
            className: "default-agent-file-sharing-edit-view anchor",
            ui: {
                saveButton: ".save-button",
                cancelButton: ".cancel-button",
                agentFileSharingEnabledToggle: ".agent-file-sharing-enabled-toggle"
            },
            uiComponents: {
                saveButton: {
                    type: Button,
                    options: {
                        el: "view.ui.saveButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_onSave"
                    }
                },
                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK
                    },
                    events: {
                        "click": "_onCancel"
                    }
                },
                agentFileSharingEnabledToggle: {
                    type: ToggleButton,
                    options: {
                        transition: ToggleButton.TRANSITION.FAST,
                        permutation: ToggleButton.PERMUTATION.NIGHT_THEME,
                        container: "view.ui.agentFileSharingEnabledToggle",
                        checked: "view._getAgentFileSharingEnabled",
                        tooltip: {
                            active: LE.translator.translate("LECampaigns.engagementDetailsView.activation.button.tooltip.enabled"),
                            inactive: LE.translator.translate("LECampaigns.engagementDetailsView.activation.button.tooltip.disabled")
                        },
                        commitStateChange: false
                    },
                    events: {
                        "toggleButton:change": "_onAgentFileSharingEnabledChanged"
                    }
                },
            },

            initialize: function (options) {
                this.settingsCollection = options.settingsCollection;

                this.isFileSharingEnabled = (this.settingsCollection.get(Settings.SETTING_ID.AGENT_FILE_SHARING_ENABLED).getValue() === ENABLED_VALUE);
            },

            onRender: function () {
            },

            _getAgentFileSharingEnabled: function () {
                return this.isFileSharingEnabled;
            },

            _onAgentFileSharingEnabledChanged: function (componentId, eventName, value) {
                this.uiComponents.agentFileSharingEnabledToggle.toggle();
                this.isFileSharingEnabled = value;
            },

            _onSave: function () {
                LEPersonalization.logger.debug("saving site settings", "AgentFileSharingEditView:_save.");
                var options = {};
                options[Settings.SETTING_ID.AGENT_FILE_SHARING_ENABLED] = (this.isFileSharingEnabled).toString();

                this.trigger("agentFileSharing:save", options);
            },

            _onCancel: function () {
                this.trigger("agentFileSharing:cancel");
            },
        });
    });

    return AgentFileSharingEditView;

});
